package com.schoolconnect.app.feature.auth

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.LaunchedEffect
import com.schoolconnect.app.util.scLog

@Composable
fun AuthFeatureRoute(
    onBack: () -> Unit,
    onAuthenticated: (String, String, String) -> Unit = { _, _, _ -> }
) {
    val viewModel = remember { AuthViewModel(onAuthenticated = onAuthenticated) }
    val uiState by viewModel.uiState.collectAsState()

    LaunchedEffect(uiState.loginId, uiState.isLoading, uiState.isOtpSent, uiState.isOtpVerified) {
        scLog("[DATA_RETRIEVE_SC] UI/AuthFeatureRoute loginId=${uiState.loginId} loading=${uiState.isLoading} otpSent=${uiState.isOtpSent} verified=${uiState.isOtpVerified} countdown=${uiState.otpCountdownSeconds}")
    }

    DisposableEffect(viewModel) {
        onDispose { viewModel.clear() }
    }

    AuthScreen(
        state = uiState,
        onEvent = viewModel::onEvent,
        onBack = onBack
    )
}
